import React from "react";
import { Col, CardBody, Card } from "reactstrap";
import client from "../../../../../../shared/api-client";
import toQueryString from "../../../../../../shared/toQueryString";
import TimeSince from "../../../../../../shared/TimeSince";
import * as users from "../../../../../../shared/service/users";

class ProfileEnrich extends React.Component {
  state = {
    company: {
      name: "",
      domainAliases: "",
      location: "",
      metrics: {
        employeesRange: "",
        estimatedAnnualRevenue: "",
      },
      category: {
        industry: "",
      },
    },
    technology: {
      ip: "",
      browser: "",
      os: "",
    },
    visitingInfo: {},
    user: {},
    lastLogins: [],
  };

  getProfileStats = () => {
    let params = toQueryString({
      uid: this.props.id,
    });

    client(`user_enrichment.php?${params}`).then((response) => {
      this.setState(response.visitorInsight);
      this.setState({ technology: response.technology });
      this.setState({ visitingInfo: response.visitingInfo });
      this.setState({ user: response.user });
    });
  };

  componentDidMount() {
    this.getProfileStats();

    users.lastLogins(this.props.id).then((response) => {
      this.setState({ lastLogins: response.events });
    });
  }

  render() {
    return (
      <React.Fragment>
        <Col md={12} lg={12} xl={12}>
          <Card className="dashboard">
            <CardBody className="profile__information">
              <div className="dashboard__sales-report">
                <div className="progress-wrap progress-wrap--small">
                  <h4>Visitor Insights</h4>
                  <hr />
                  <p className="">
                    <strong>Company</strong> : {this.state.company.name}
                  </p>
                  <p className="">
                    <strong>Domain</strong> : <i>{this.state.company.domain}</i>
                  </p>
                  <p className="">
                    <strong>Location</strong> : {this.state.company.location}
                  </p>
                  <p className="">
                    <strong>Type</strong> :
                    {this.state.company.category.industry}
                  </p>
                  <p className="">
                    <strong>Revenue</strong> :
                    {this.state.company.metrics.estimatedAnnualRevenue}
                  </p>
                  <p className="">
                    <strong>Employees</strong> :
                    {this.state.company.metrics.employeesRange}
                  </p>
                  <br />
                  <br />
                  <h4>Technology</h4>
                  <hr />
                  <p className="">
                    <strong>IP Address</strong> : {this.state.technology.ip}
                  </p>
                  <p className="">
                    <strong>Browser</strong> : {this.state.technology.browser}
                  </p>

                  <p className="">
                    <strong>OS Device</strong> : {this.state.technology.os}
                  </p>
                  <br />
                  <br />
                  <h4>Last Login</h4>
                  <hr />
                  <p className="">
                    {this.state.lastLogins.map((lastLogin) => (
                      <li>
                        {TimeSince(lastLogin.timestamp)}{" "}
                        <small>({lastLogin.action})</small>
                      </li>
                    ))}
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

export default ProfileEnrich;
